/**
 * @generated SignedSource<<d163fc4f275b8627d08e1517c8efdf8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoPageDirectLinkQuery$variables = {
  eventPassword?: string | null | undefined;
  eventUser?: string | null | undefined;
  id: string;
  listId: string;
};
export type VideoPageDirectLinkQuery$data = {
  readonly event: {
    readonly " $fragmentSpreads": FragmentRefs<"VideoPageEventData">;
  } | null | undefined;
  readonly playlist: {
    readonly " $fragmentSpreads": FragmentRefs<"PlaylistBlockPlaylistData">;
  } | null | undefined;
  readonly realm: {
    readonly " $fragmentSpreads": FragmentRefs<"NavigationData" | "VideoPageRealmData">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"UserData">;
};
export type VideoPageDirectLinkQuery = {
  response: VideoPageDirectLinkQuery$data;
  variables: VideoPageDirectLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventPassword"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "listId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creators",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opencastId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canWrite",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBookmark",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "SyncedEventData",
  "kind": "LinkedField",
  "name": "syncedData",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "audioOnly",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoPageDirectLinkQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserData"
      },
      {
        "alias": "event",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventById",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "eventPassword",
                "variableName": "eventPassword"
              },
              {
                "kind": "Variable",
                "name": "eventUser",
                "variableName": "eventUser"
              }
            ],
            "kind": "FragmentSpread",
            "name": "VideoPageEventData"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "realm",
        "args": null,
        "concreteType": "Realm",
        "kind": "LinkedField",
        "name": "rootRealm",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VideoPageRealmData"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NavigationData"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "playlist",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "playlistById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlaylistBlockPlaylistData"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VideoPageDirectLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRealmHandle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseStudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseEditor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateUserRealm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateSeries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreatePlaylists",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTobiraAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canFindUnlisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRole",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "event",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventById",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isEvent"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "metadata",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SyncedEventData",
                "kind": "LinkedField",
                "name": "syncedData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updated",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "password",
                    "variableName": "eventPassword"
                  },
                  {
                    "kind": "Variable",
                    "name": "user",
                    "variableName": "eventUser"
                  }
                ],
                "concreteType": "AuthorizedEventData",
                "kind": "LinkedField",
                "name": "authorizedData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Track",
                    "kind": "LinkedField",
                    "name": "tracks",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flavor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mimetype",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resolution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMaster",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Caption",
                    "kind": "LinkedField",
                    "name": "captions",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lang",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Segment",
                    "kind": "LinkedField",
                    "name": "segments",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Series",
                "kind": "LinkedField",
                "name": "series",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v13/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v10/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPublicVideos",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "entries",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v11/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v9/*: any*/),
                          (v21/*: any*/)
                        ],
                        "type": "AuthorizedEvent",
                        "abstractKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AuthorizedEvent",
            "abstractKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "realm",
        "args": null,
        "concreteType": "Realm",
        "kind": "LinkedField",
        "name": "rootRealm",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMainRoot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Realm",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v23/*: any*/),
              (v24/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RealmNav",
            "kind": "LinkedField",
            "name": "nav",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RealmNavItem",
                "kind": "LinkedField",
                "name": "header",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RealmNavItem",
                "kind": "LinkedField",
                "name": "list",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasChildren",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "listOrder",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "playlist",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "playlistById",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isPlaylist"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creator",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPublicRssFeed",
                "storageKey": null
              },
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlaylistEntry",
                "kind": "LinkedField",
                "name": "entries",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v11/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Series",
                            "kind": "LinkedField",
                            "name": "series",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "type": "AuthorizedEvent",
                        "abstractKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AuthorizedPlaylist",
            "abstractKey": null
          },
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d10bbd3beb51f6aafb147fa0afab9d35",
    "id": null,
    "metadata": {},
    "name": "VideoPageDirectLinkQuery",
    "operationKind": "query",
    "text": "query VideoPageDirectLinkQuery(\n  $id: ID!\n  $listId: ID!\n  $eventUser: String\n  $eventPassword: String\n) {\n  ...UserData\n  event: eventById(id: $id) {\n    __typename\n    ...VideoPageEventData_3J3oez\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  realm: rootRealm {\n    ...VideoPageRealmData\n    ...NavigationData\n    id\n  }\n  playlist: playlistById(id: $listId) {\n    __typename\n    ...PlaylistBlockPlaylistData\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment NavigationData on Realm {\n  id\n  name\n  path\n  nav {\n    header {\n      name\n      path\n    }\n    list {\n      name\n      path\n      hasChildren\n    }\n    listOrder\n  }\n}\n\nfragment PlaylistBlockPlaylistData on Playlist {\n  __isPlaylist: __typename\n  __typename\n  ... on NotAllowed {\n    __typename\n  }\n  ... on AuthorizedPlaylist {\n    id\n    title\n    description\n    creator\n    canWrite\n    hasPublicRssFeed\n    isBookmark\n    entries {\n      node {\n        __typename\n        ... on AuthorizedEvent {\n          ...VideoListEventData_3lvuy\n        }\n        ... on Missing {\n          __typename\n        }\n        ... on NotAllowed {\n          __typename\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SeriesBlockSeriesData on Series {\n  id\n  title\n  created\n  creators\n  description\n  state\n  isBookmark\n  canWrite\n  hasPublicVideos\n  entries {\n    __typename\n    ... on AuthorizedEvent {\n      ...VideoListEventData_1FrHo3\n    }\n    ... on NotAllowed {\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment UserData on Query {\n  currentUser {\n    username\n    displayName\n    userRealmHandle\n    canUpload\n    canUseStudio\n    canUseEditor\n    canCreateUserRealm\n    canCreateSeries\n    canCreatePlaylists\n    isTobiraAdmin\n    isAdmin\n    canFindUnlisted\n    roles\n    userRole\n  }\n}\n\nfragment VideoListEventData_1FrHo3 on AuthorizedEvent {\n  id\n  title\n  created\n  creators\n  isLive\n  description\n  syncedData {\n    thumbnail\n    duration\n    startTime\n    endTime\n    audioOnly\n  }\n}\n\nfragment VideoListEventData_3lvuy on AuthorizedEvent {\n  id\n  title\n  created\n  creators\n  isLive\n  description\n  series {\n    title\n    id\n  }\n  syncedData {\n    thumbnail\n    duration\n    startTime\n    endTime\n    audioOnly\n  }\n}\n\nfragment VideoPageAuthorizedData_3J3oez on AuthorizedEvent {\n  authorizedData(user: $eventUser, password: $eventPassword) {\n    tracks {\n      uri\n      flavor\n      mimetype\n      resolution\n      isMaster\n    }\n    captions {\n      uri\n      lang\n    }\n    segments {\n      uri\n      startTime\n    }\n  }\n  id\n}\n\nfragment VideoPageEventData_3J3oez on Event {\n  __isEvent: __typename\n  __typename\n  ... on NotAllowed {\n    __typename\n  }\n  ... on AuthorizedEvent {\n    id\n    title\n    description\n    creators\n    created\n    isLive\n    opencastId\n    metadata\n    canWrite\n    hasPassword\n    syncedData {\n      updated\n      duration\n      startTime\n      endTime\n      thumbnail\n    }\n    ...VideoPageAuthorizedData_3J3oez\n    series {\n      id\n      opencastId\n      title\n      ...SeriesBlockSeriesData\n    }\n  }\n}\n\nfragment VideoPageRealmData on Realm {\n  name\n  path\n  isMainRoot\n  ancestors {\n    name\n    path\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "827d28d67f8a831c38bcffcf1a7a3a9a";

export default node;
